import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const pillars = ['Materiales', 'Técnicas Pro', 'Moldes', 'Sellado', 'Fotografía', 'Meta Ads'];
const tomos = [{
  n: 1,
  title: 'Fundamentos Elite',
  desc: 'Tipos de cemento, arena y cal disponibles en Argentina. Cuál usar según el objeto que querés fabricar y dónde conseguirlos al mejor precio mayorista.'
}, {
  n: 2,
  title: 'Química Pro: Cero Grietas',
  desc: 'Aditivos, fibras y plastificantes que transforman una mezcla básica en un material de lujo. La fórmula exacta para que tus piezas no se quiebren jamás.'
}, {
  n: 3,
  title: 'Colorimetría y Pigmentos',
  desc: 'Colores perfectos y efectos veteados con pigmentos oxidados y naturales. Las paletas que más se venden en el mercado decorativo argentino 2026.'
}, {
  n: 4,
  title: 'Técnica Terrazo Moderno',
  desc: 'El estilo que más factura hoy. Paso a paso del efecto terrazo con agregados de mármol, vidrio y piedras que elevan el precio de cualquier pieza al doble.'
}, {
  n: 5,
  title: 'Moldes Maestros',
  desc: 'Cómo fabricar tus propios moldes de silicona, caucho y madera desde casa. Dejá de gastar en moldes importados que se rompen al tercer uso.'
}, {
  n: 6,
  title: 'Vaciado Perfecto',
  desc: 'La técnica de vertido para eliminar burbujas de aire y lograr un acabado espejo desde adentro. Terminación nivel boutique desde el primer desmolde.'
}, {
  n: 7,
  title: 'Curado e Impermeabilización',
  desc: 'Los tiempos exactos de curado según el clima de tu ciudad y cómo aplicar selladores de grado industrial con calidad de exportación.'
}, {
  n: 8,
  title: 'Lijado, Pulido y Tacto Seda',
  desc: 'El proceso de terminación en 5 pasos que transforma una pieza rústica en un objeto de diseño que se vende un 300% más caro. El acabado que genera el efecto WOW.'
}, {
  n: 9,
  title: 'Packaging que Enamora',
  desc: 'Cómo envolver y presentar tus piezas con materiales económicos que justifican precios premium. El unboxing que genera recomendaciones orgánicas.'
}, {
  n: 10,
  title: 'Costos, Márgenes y Precios Reales',
  desc: 'Ingeniería de precios anti-inflación: materiales, tiempo, packaging, envío y comisiones de Mercado Pago para no vender nunca más a pérdida.'
}, {
  n: 11,
  title: 'Instagram para Cemento',
  desc: 'Estrategia de contenido orgánico para objetos de decoración. Una estética de feed que genera confianza y pedidos reales sin pagar publicidad todavía.'
}, {
  n: 12,
  title: 'Hoja de Ruta: Tu Taller en 30 Días',
  desc: 'El plan diario para ir de "cero materiales" a "primera venta realizada" en exactamente un mes, con checklist de implementación día a día.'
}];
const includes = ['Técnicas listas para aplicar', 'Protocolos paso a paso', 'Plantillas editables', 'Ejemplos del mercado ARG', 'Checklists de implementación', 'Cálculo con inflación real', 'Proveedores ARG verificados', 'Listo para aplicar desde hoy'];
export function Tomos() {
  return <section aria-label="Los 12 tomos" className="bg-ink" data-id="element-165" data-mp="3l9voi6laemca">
      <div className="mx-auto max-w-6xl px-5 pt-[4px] pb-[28px]" data-id="element-166" data-mp="37b4bkni5v6pq">
        <div className="pt-[14px] text-center" data-id="element-167" data-mp="37aw0901os9gn">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" data-id="element-168" data-mp="3c9pc6o1brsep">
            🏆 ACADEMIA CEMENTO ELITE™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl" data-id="element-169" data-mp="2xjrk3x09yik8">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-170" data-mp="32dvu6p4u76pj">100+ páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-171" data-mp="2oijndjdepps9">
            {pillars.map(p => <span key={p} className="rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-gold" data-id="element-172" data-mp="2thd19cwlvisy">
                {p}
              </span>)}
          </div>
          <p className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-cemento" data-id="element-173" data-mp="3mv5rjfkb7v9h">
            📚 Los 12 tomos estratégicos
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-174" data-mp="3d6e33hegjt3b">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="group rounded-2xl border border-white/10 bg-ink-2 p-5 transition-colors duration-200 hover:border-gold/50" data-id="element-175" data-mp="3882sv5k93gkk" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-176" data-mp="2p9qgzc1yfsla">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 font-display text-lg font-black text-cemento-soft" data-id="element-177" data-mp="sgev57xexk0p">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-178" data-mp="v1mn0ko55rge">{t.title}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-179" data-mp="zywc1z7mc13p">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-gold/25 bg-ink-2 p-6" data-id="element-180" data-mp="14sr1lj9wnaap">
          <p className="text-center font-display text-lg font-black text-gold" data-id="element-181" data-mp="19p7sgl8ho2rh">
            ✅ Cada tomo incluye
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-182" data-mp="c4d2f072y7xk">
            {includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/75" data-id="element-183" data-mp="m06fqlsmi5ge">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} data-id="element-184" data-mp="m2j35eh5h80u" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}